import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getStatusKey } from '../StatusBadge/StatusBadge';
import './InventoryAssetHealth.css';

function InventoryAssetHealth({ data = [] }) {
    const assignedAssets = useMemo(() => {
        return data
            .filter((h) => getStatusKey(h.siteqp, h.comVinculo) === 'assigned')
            .slice(0, 5)
            .map((h) => ({
                codhar: h.codhar,
                label: (h.deseqp || h.pateqp || `#${h.codhar}`).toString().trim().split('\n')[0].substring(0, 40)
            }));
    }, [data]);

    const inMaintenanceAssets = useMemo(() => {
        return data
            .filter((h) => getStatusKey(h.siteqp, h.comVinculo) === 'inMaintenance')
            .slice(0, 5)
            .map((h) => ({
                codhar: h.codhar,
                label: (h.deseqp || h.pateqp || `#${h.codhar}`).toString().trim().split('\n')[0].substring(0, 40)
            }));
    }, [data]);

    return (
        <div className="inventory-asset-health">
            <div className="inventory-asset-health__block">
                <h3 className="inventory-asset-health__title">
                    <i className="fas fa-user-check inventory-asset-health__icon" aria-hidden="true" />
                    Ativos atribuídos (amostra)
                </h3>
                {assignedAssets.length > 0 ? (
                    <ul className="inventory-asset-health__list">
                        {assignedAssets.map((a) => (
                            <li key={a.codhar}>
                                <Link to={`/hardware/${a.codhar}`} className="inventory-asset-health__link">
                                    {a.label || `#${a.codhar}`}
                                </Link>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="inventory-asset-health__empty">Nenhum ativo atribuído na lista atual.</p>
                )}
            </div>
            <div className="inventory-asset-health__block">
                <h3 className="inventory-asset-health__title">
                    <i className="fas fa-wrench inventory-asset-health__icon" aria-hidden="true" />
                    Em manutenção (amostra)
                </h3>
                {inMaintenanceAssets.length > 0 ? (
                    <ul className="inventory-asset-health__list">
                        {inMaintenanceAssets.map((a) => (
                            <li key={a.codhar}>
                                <Link to={`/hardware/${a.codhar}`} className="inventory-asset-health__link">
                                    {a.label || `#${a.codhar}`}
                                </Link>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="inventory-asset-health__empty">Nenhum ativo em manutenção na lista atual.</p>
                )}
            </div>
            <div className="inventory-asset-health__block">
                <h3 className="inventory-asset-health__title">
                    <i className="fas fa-ticket-alt inventory-asset-health__icon" aria-hidden="true" />
                    Chamados e manutenções por ativo
                </h3>
                <p className="inventory-asset-health__hint">
                    O histórico de cada ativo (chamados, manutenções, vinculações) está disponível na página do ativo ou em{' '}
                    <Link to="/listaHisHar" className="inventory-asset-health__link">Histórico de hardwares</Link>.
                </p>
            </div>
        </div>
    );
}

export default InventoryAssetHealth;
